/**
 * Google Analytics 4 (GA4) utility functions.
 * Provides safe, client-side tracking for page views and custom events.
 * Only functions when gtag is available (i.e., in production after scripts load).
 */

// GA4 Measurement ID from environment variables
export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

/**
 * Track a page view in GA4.
 * @param {string} url - The page URL to track (e.g., current pathname).
 */
export const pageview = (url) => {
  // Ensure gtag is loaded and available
  if (typeof window !== "undefined" && typeof window.gtag !== "undefined") {
    window.gtag("config", GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

/**
 * Track a custom event in GA4.
 * @param {Object} params - Event parameters.
 * @param {string} params.action - The event action (e.g., 'click').
 * @param {string} params.category - The event category (e.g., 'button').
 * @param {string} params.label - The event label (e.g., 'submit').
 * @param {number} [params.value] - Optional numeric value for the event.
 */
export const event = ({ action, category, label, value }) => {
  // Ensure gtag is loaded and available
  if (typeof window !== "undefined" && typeof window.gtag !== "undefined") {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
